import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-enter-amount-dialog',
  templateUrl: './enter-amount-dialog.component.html',
  styleUrls: ['./enter-amount-dialog.component.less']
})
export class EnterAmountDialogComponent implements OnInit {
  transition = false;
  title = 'Title';
  message = 'Message';
  confirmButtonText = 'Ok';
  cancelButtonText = 'Cancel';
  confirmButtonIcon = 'sporticon sporticon-delete';
  confirmButtonColor = 'outline-success';
  inputValue: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) {
    if (this.data) {
      this.message = data.message || this.message;
      this.title = data.title || this.title;

      if (data.buttonText) {
        this.confirmButtonText = this.data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = this.data.buttonText.cancel || this.cancelButtonText;
      }

      setTimeout(() => {
        this.transition = true;
      }, 200);
    }
  }

  ngOnInit(): void {
  }

  confirmClick(): void {
    this.dialogRef.close({confirmed: true, inputValue: this.inputValue});
  }

  cancelClick(): void {
    this.dialogRef.close({confirmed: false, inputValue: null});
  }

}
